export enum BorrowerType {
    Individual = 'Individual',
    LegalEntity = 'LegalEntity'
}
